module.exports = __webpack_public_path__ + "img/ru.ee12d148.svg";